export type Lang = 'en' | 'ru' | 'zh';

export const translations: Record<Lang, Record<string, string>> = {
    en: {
        'Load HDR surface': 'Load HDR surface',
        'Exposure (EV)': 'Exposure (EV)',
        'HDR surface: exposure and display mapping only.': 'HDR surface: exposure and display mapping only.',
        'Use GLB texture': 'Use GLB texture',
        'HDR source texture': 'HDR source texture',
        'Environment brightness (EV)': 'Environment brightness (EV)',
        'SDR LUT is applied in SDR preview only. Disable HDR output to see it.': 'SDR LUT is applied in SDR preview only. Disable HDR output to see it.',
        'HDR output: on. Click for SDR preview.': 'HDR output: on. Click for SDR preview.',
        'SDR preview: click for HDR output.': 'SDR preview: click for HDR output.',
        'HDR output is unavailable in this session. The HDR texture is shown in SDR.': 'HDR output is unavailable in this session. The HDR texture is shown in SDR.',
        Settings: 'Settings',
        'Post-processing': 'POST-PROCESSING',
        'Sharpness (RCAS)': 'Sharpness (RCAS)',
        'Load LUT': 'Load LUT',
        'Clear LUT': 'Clear LUT',
        'LUT intensity': 'LUT intensity',
        'Colour vision profile': 'CVD profile',
        'No colour vision profile': 'No colour vision profile',
        'Colour vision profile could not be loaded': 'Colour vision profile could not be loaded',
        'compensation profile suffix': 'comp.',
        'simulation profile suffix': 'sim.',
        'The list contains author simulations and experimental compensation profiles; the profile purpose is shown after its name.':
            'The list contains author simulations and experimental compensation profiles; the profile purpose is shown after its name.',
        'SSAO intensity': 'SSAO intensity',
        'SSAO radius': 'SSAO radius',
        'Color LUT must be a horizontal strip, for example 256 x 16 pixels.': 'Color LUT must be a horizontal strip, for example 256 x 16 pixels.',
        'Color LUT file must be 8 MB or smaller.': 'Color LUT file must be 8 MB or smaller.',
        'Color LUT must be no larger than 4096 x 64 pixels (64³ colors).': 'Color LUT must be no larger than 4096 x 64 pixels (64³ colors).',
        Materials: 'Materials',
        POI: 'POI',
        Camera: 'CAMERA',
        Sky: 'ENVIRONMENT',
        Light: 'LIGHT',
        'Export viewer settings': 'Export viewer settings',
        'Add POI': 'Add POI',
        'Clear POIs': 'Clear POIs',
        'No POIs yet.': 'No POIs yet.',
        Delete: 'Delete',
        'Click on the model surface to place a POI.': 'Click on the model surface to place a POI.',
        'Capture View': 'Capture View',
        'Retake View': 'Retake View',
        'Delete View': 'Delete View',
        'Active Camera': 'Active Camera',
        Fov: 'Fov',
        Tonemap: 'Tonemap',
        'Pixel Scale': 'Pixel Scale',
        'Lower while moving': 'Lower while moving (experimental)',
        'RCAS: contrast-adaptive sharpening from AMD FidelityFX FSR 1.0. Boosts edges and leaves flat areas untouched.':
            'RCAS: contrast-adaptive sharpening from AMD FidelityFX FSR 1.0. Boosts edges and leaves flat areas untouched.',
        'EASU: edge-preserving upscaling from AMD FidelityFX FSR 1.0. Works only when pixel scale is above one.':
            'EASU: edge-preserving upscaling from AMD FidelityFX FSR 1.0. Works only when pixel scale is above one.',
        'TAA combines current and previous frames to reduce jagged edges and shimmer. It can leave trails on moving objects.':
            'TAA combines current and previous frames to reduce jagged edges and shimmer. It can leave trails on moving objects.',
        'Color LUT remaps the image colors using a lookup texture for consistent color grading.':
            'Color LUT remaps the image colors using a lookup texture for consistent color grading.',
        'SSAO adds soft contact shadows in creases and where surfaces meet.':
            'SSAO adds soft contact shadows in creases and where surfaces meet.',
        'MSAA smooths polygon edges within one frame. It is automatically disabled when TAA is enabled.':
            'MSAA smooths polygon edges within one frame. It is automatically disabled when TAA is enabled.',
        'Manual distance limits': 'Manual distance limits',
        'Camera limits': 'Camera limits',
        'Tile loading order': 'Tile loading order',
        'Tiles': 'Tiles',
        'Center of view first': 'Center of view first',
        'Under the cursor first': 'Under the cursor first',
        'Around the grab point first': 'Around the grab point first',
        'By error and distance': 'Coarsest first',
        'Min distance': 'Min distance',
        'Max distance': 'Max distance',
        'Current distance': 'Current distance',
        'Near from view': 'Near from view',
        'Far from view': 'Far from view',
        'Use the current camera distance as the near limit': 'Use the current camera distance as the near limit',
        'Use the current camera distance as the far limit': 'Use the current camera distance as the far limit',
        Viewport: 'Viewport',
        Multisample: 'Multisample',
        HD: 'HD',
        Environment: 'Environment',
        'Environment Map': 'Environment Map',
        Exposure: 'Exposure',
        Rotation: 'Rotation',
        Background: 'Background',
        'Background Color': 'Background Color',
        Blur: 'Blur',
        Scale: 'Scale',
        'Tripod Offset': 'Tripod Offset',
        Enabled: 'Enabled',
        'Follow Camera': 'Follow Camera',
        Color: 'Color',
        Intensity: 'Intensity',
        'Cast Shadow': 'Cast Shadow',
        'Shadow Catcher': 'Shadow Catcher',
        'Catcher Intensity': 'Catcher Intensity',
        'Catcher Height': 'Catcher Height',
        'Current Device': 'Current Device',
        'Graphics Backend': 'Graphics Backend',
        'Active Backend': 'Active Backend',
        'Auto (recommended)': 'Auto (recommended)',
        'WebGPU is not available on this device': 'WebGPU is not available on this device',
        'Switching restarts the viewer': 'Switching restarts the viewer',
        'Use WebGPU': 'Use WebGPU',
        Grid: 'Grid',
        Axes: 'Axes',
        Skeleton: 'Skeleton',
        Bounds: 'Bounds',
        Wireframe: 'Wireframe',
        'Tiles Debug': 'Tiles Debug',
        'Tile Bounds (OBB)': 'Tile Bounds (OBB)',
        'By State': 'By State',
        'By LOD': 'By LOD',
        'By Resolution': 'By Resolution',
        'Isolate LOD': 'Isolate LOD',
        'Replay loading': 'Replay loading',
        'Step back': 'Step back',
        'Record again': 'Record again',
        'LOD {level} first appeared · frame {frame}': 'LOD {level} first appeared · frame {frame}',
        'LOD {level} last load in recording · frame {frame}': 'LOD {level} last load in recording · frame {frame}',
        'POI timeline': 'POI timeline',
        'Observe camera externally': 'Observe camera externally',
        'Time unit': 'Time unit',
        Timecode: 'Timecode',
        Minutes: 'Minutes',
        Seconds: 'Seconds',
        Milliseconds: 'Milliseconds',
        Frames: 'Frames',
        'Camera transition': 'Camera transition',
        Hold: 'Hold',
        'Drag to change camera transition duration': 'Drag to change camera transition duration',
        'Drag to change hold duration': 'Drag to change hold duration',
        'Add a POI to build the timeline': 'Add a POI to build the timeline',
        'Start recording': 'Start recording',
        'Stop recording': 'Stop recording',
        'Exit timeline': 'Exit timeline',
        Loop: 'Loop',
        'Step forward': 'Step forward',
        'Rewinds the view along the recorded load order; leftmost position shows the scene as it is now.':
            'Rewinds the view along the recorded load order; leftmost position shows the scene as it is now.',
        'Load order': 'Load order',
        'Tile ID': 'Tile ID',
        'Tile labels': 'Labels',
        'Leftmost position turns isolation off; further right shows only the chosen level.':
            'Leftmost position turns isolation off; further right shows only the chosen level.',
        'Color the model': 'Color the model',
        'Colours tiles by how far their screen-space error is from the target: red is coarser than asked for, white is on target, blue is finer than needed.':
            'Colours tiles by how far their screen-space error is from the target: red is coarser than asked for, white is on target, blue is finer than needed.',
        'Spatial LOD Debug': 'Spatial LOD Debug',
        'Color Splats by LOD': 'Color Splats by LOD',
        'Color Tiles by LOD': 'Color Tiles by LOD',
        'Spatial Node Bounds': 'Spatial Node Bounds',
        'LOD diagnostics use the live streaming state.': 'LOD diagnostics use the live streaming state.',
        'Freeze LOD Camera': 'Freeze LOD Camera',
        'Line Thickness': 'Line Thickness',
        'Solid Frame': 'Uniform Frame',
        'Checker Frame': 'Checker Frame',
        'Checker Fill': 'Checker Fill',
        'Pick Tile': 'Pick Tile',
        'Load order numbers': 'Load order numbers',
        'Tile ID numbers': 'Tile ID numbers',
        'Resume Loading': 'Resume Loading',
        'Frame style': 'Frame style',
        'Number within each LOD': 'Number within each LOD',
        'Isolate Picked Tile': 'Isolate Picked Tile',
        'Freeze Camera + FOV': 'Freeze Camera + FOV',
        'Pause Loading': 'Pause Loading',
        'Isolate LOD Level': 'Isolate LOD Level',
        'LOD Level': 'LOD Level',
        'Vertex Normals': 'Vertex Normals',
        'Wireframe Color': 'Wireframe Color',
        'Checker Scale': 'Checker Scale',
        'With texture': 'With texture',
        Geometry: 'GEOMETRY',
        'Drag & drop .glb, .gltf, .ply, .sog, .spz or .3tz files, or click to open files': 'Drag & drop .glb, .gltf, .ply, .sog, .spz or .3tz files, or click to open files',
        'Click to open files': 'Click to open files',
        OR: 'OR',
        'LOAD MODEL FROM URL': 'LOAD MODEL FROM URL',
        'ID': 'ID',
        'Info': 'Info',
        Path: 'Path',
        Name: 'Name',
        'Copy path': 'Copy path',
        'TWIN_ID': 'TWIN_ID',
        'Copy TWIN_ID': 'Copy TWIN_ID',
        'TWIN_ID not assigned': 'TWIN_ID not assigned',
        'Permanent digital twin identifier': 'Permanent digital twin identifier',
        'Left panel': 'Left panel',
        'Tour': 'Tour',
        'Measure': 'Measure',
        'Model info': 'Model info',
        'Fit': 'Fit',
        'Reset': 'Reset',
        'Interface elements': 'Interface elements',
        'Advanced': 'Advanced',
        'Parent origin': 'Parent origin',
        'Allowed parent site origin for embed messaging': 'Allowed parent site origin for embed messaging',
        'shown': 'shown',
        'hidden': 'hidden',
        'Show embed code': 'Show embed code',
        'Hide embed code': 'Hide embed code',
        'Select a node in the hierarchy (Model tab).': 'Select a node in the hierarchy (Model tab).',
        'HD mode': 'HD mode',
        'SD mode': 'SD mode',
        'Measurement': 'Measurement',
        'Fragment view': 'Fragment view',
        'Highlight section outline': 'Highlight section outline',
        'Outline width': 'Outline width',
        'SELECT FRAGMENT': 'SELECT FRAGMENT',
        'CLICK MODEL TO PLACE BOX': 'CLICK MODEL TO PLACE BOX',
        'ISOLATE FRAGMENT': 'ISOLATE FRAGMENT',
        'EXIT ISOLATION': 'EXIT ISOLATION',
        'EXIT MODE': 'EXIT MODE',
        'Click the model where the fragment box should appear.': 'Click the model where the fragment box should appear.',
        'Adjust the box, then isolate the selected fragment.': 'Adjust the box, then isolate the selected fragment.',
        'Enable clipping box': 'Enable clipping box',
        'Move box': 'Move box',
        'Resize box': 'Resize box',
        'Rotate box': 'Rotate box',
        'Box shape': 'Box shape',
        'Sphere shape': 'Sphere shape',
        'Show outside box': 'Show outside box',
        Center: 'Center',
        Size: 'Size',
        'FIT BOX TO MODEL': 'FIT BOX TO MODEL',
        'RESET VIEW': 'RESET VIEW',
        'The box clips geometry exactly; tile boundaries do not affect the cut.': 'The box clips geometry exactly; tile boundaries do not affect the cut.',
        'Export measurements JSON': 'Export measurements JSON',
        'View & share': 'View & share',
        'Frame scene': 'Frame scene',
        'Orbit mode': 'Orbit mode',
        'Fly mode': 'Fly mode',
        'Walk mode': 'Walk mode',
        'Fullscreen': 'Fullscreen',
        'Exit fullscreen': 'Exit fullscreen',
        'View in AR': 'View in AR',
        'Play': 'Play',
        'Pause': 'Pause',
        'Stop': 'Stop',
        'Previous POI': 'Previous POI',
        'Next POI': 'Next POI',
        'Texture resolution in pixels': 'Texture resolution in pixels',
        'GPU-compressed texture: the card reads it as is, no CPU unpacking': 'GPU-compressed texture: the card reads it as is, no CPU unpacking',
        'Uncompressed pixels: unpacked by the CPU and uploaded raw': 'Uncompressed pixels: unpacked by the CPU and uploaded raw',
        Controls: 'Controls',
        'Theme color': 'Theme color',
        Model: 'Model',
        About: 'About',
        Desktop: 'Desktop',
        Touch: 'Touch',
        'Orbit Mode': 'Orbit Mode',
        Orbit: 'Orbit',
        Pan: 'Pan',
        Zoom: 'Zoom',
        'Set Focus': 'Set Focus',
        'Set Focus and Zoom One Step': 'Set Focus and Zoom One Step',
        'Fly Mode': 'Fly Mode',
        'Look Around': 'Look Around',
        Fly: 'Fly',
        'Movement speed': 'Movement speed',
        'Surface pivot': 'Surface pivot',
        'Invert mouse buttons': 'Invert mouse buttons',
        'Pointer device': 'Pointer device',
        'Detect automatically': 'Detect automatically',
        'Mouse': 'Mouse',
        'Trackpad': 'Trackpad',
        General: 'General',
        'Frame Scene': 'Frame Scene',
        'Reset Camera': 'Reset Camera',
        'Left Mouse': 'Left Mouse',
        'Right Mouse': 'Right Mouse',
        'Mouse Wheel': 'Mouse Wheel',
        'Double Click': 'Double Click',
        'One Finger Drag': 'One Finger Drag',
        'Two Finger Drag': 'Two Finger Drag',
        Pinch: 'Pinch',
        'Double Tap': 'Double Tap',
        'Touch on Right': 'Touch on Right',
        'Touch on Left': 'Touch on Left',
        Filename: 'Filename',
        Meshes: 'Meshes',
        Textures: 'Textures',
        Primitives: 'Primitives',
        Verts: 'Verts',
        'Mesh VRAM': 'Mesh VRAM',
        'Texture VRAM': 'Texture VRAM',
        'Texel Density': 'Texel Density',
        'Texel Density Top': 'Texel Density Top',
        'Pick object': 'Pick object',
        Heatmap: 'Heatmap',
        'Selected object': 'Selected object',
        'UV Layout': 'UV Layout',
        'UV Set': 'UV Set',
        'Active UV': 'Active UV',
        'Material Variant': 'Material Variant',
        'Texture Layers': 'Texture Layers',
        'Original material': 'Original material',
        'Quick layer color': 'Quick layer color',
        'Add layer to quick switcher': 'Add layer to quick switcher',
        'PBR Factors': 'PBR Factors',
        'By objects': 'By objects',
        'Diffuse Color': 'Diffuse Color',
        'Specular Color': 'Specular Color',
        Metallic: 'Metallic',
        Roughness: 'Roughness',
        Opacity: 'Opacity',
        'Enable By objects and click an object.': 'Enable By objects and click an object.',
        'No editable PBR factors.': 'No editable PBR factors.',
        'Texture Size': 'Texture Size',
        'Texture Channel': 'Texture Channel',
        Triangles: 'Triangles',
        'Surface Area': 'Surface Area',
        Submaterial: 'Submaterial',
        'Enable object picker to inspect texel density.': 'Enable object picker to inspect texel density.',
        'Click an object in the viewport.': 'Click an object in the viewport.',
        'Texel Density by Material': 'Texel Density by Material',
        'Load time': 'Load time',
        Hierarchy: 'Hierarchy',
        Variant: 'Variant',
        'No model loaded. Drag & drop a glTF/GLB file.': 'No model loaded. Drag & drop a glTF/GLB file.',
        'No hierarchy data.': 'No hierarchy data.',
        'No model loaded.': 'No model loaded.',
        Stats: 'Stats',
        'Show performance stats': 'Show performance stats',
        'This viewer is a modified version of the open-source project PlayCanvas Model Viewer (MIT License):': 'This viewer is a modified version of the open-source project PlayCanvas Model Viewer (MIT License):',
        'UI components are based on PlayCanvas PCUI (MIT License):': 'UI components are based on PlayCanvas PCUI (MIT License):',
        'Icons: Google Material Icons': 'Icons: Google Material Icons',
        'Flags: flag-icons': 'Flags: flag-icons',
        'Tile streaming architecture inspired by NASA-AMMOS/3DTilesRendererJS (Apache License 2.0):': 'Tile streaming architecture inspired by NASA-AMMOS/3DTilesRendererJS (Apache License 2.0):',
        'Edge upscaling and sharpening use the AMD FidelityFX FSR 1.0 algorithms, EASU and RCAS (MIT License):': 'Edge upscaling and sharpening use the AMD FidelityFX FSR 1.0 algorithms, EASU and RCAS (MIT License):',
        'HERITAGE3D.RU Project': 'HERITAGE3D.RU Project',
        'Measure Mode': 'Measure Mode',
        'Enable measuring': 'Enable measuring',
        'Show helpers': 'Show helpers',
        'Scale bar': 'Scale bar',
        'Scene scale': 'Scene scale',
        'Clear measurements': 'Clear measurements',
        'Click to change units': 'Click to change units',
        'Click and enter the real length': 'Click and enter the real length',
        'Or enter the real length on the segment label': 'Or enter the real length on the segment label',
        Step: 'Step',
        'scale at the measured segment': 'scale at the measured segment',
        'scale at the surface in the centre of the frame': 'scale at the surface in the centre of the frame',
        'Reference Figure': 'Reference Figure',
        Human: 'Human',
        Units: 'Units',
        'millimeters (mm)': 'millimeters (mm)',
        'centimeters (cm)': 'centimeters (cm)',
        'meters (m)': 'meters (m)',
        '1 Unit = (m)': '1 Unit = (m)',
        'Known distance': 'Known distance',
        'Only one known segment can be used for scene scale. A new distance replaces the previous one.': 'Only one known segment can be used for scene scale. A new distance replaces the previous one.',
        'RECALCULATE SCENE SIZE': 'RECALCULATE SCENE SIZE',
        'Last Distance': 'Last Distance',
        'Last Angle': 'Last Angle',
        'Last Area': 'Last Area',
        'Planarity deviation': 'Planarity deviation',
        'Distance tool': 'Distance tool',
        'Angle tool': 'Angle tool',
        'Area tool': 'Area tool',
        Points: 'Points',
        'Pick first point': 'Pick first point',
        'Pick second point': 'Pick second point',
        'Pick third point': 'Pick third point',
        'Pick fourth point': 'Pick fourth point',
        'Pick next point or close polygon': 'Pick next point or close polygon',
        'CLEAR MEASUREMENT': 'CLEAR MEASUREMENT',
        'CLEAR MEASUREMENTS': 'CLEAR MEASUREMENTS',
        'View and share on mobile with QR code': 'View and share on mobile with QR code',
        'View and share on mobile with URL': 'View and share on mobile with URL',
        'Embed Type': 'Embed Type',
        Responsive: 'Responsive',
        Fixed: 'Fixed',
        'UI Preset': 'UI Preset',
        'Show left panel': 'Show left panel',
        Autoplay: 'Autoplay',
        'Allow fullscreen': 'Allow fullscreen',
        'Show POI': 'Show POI',
        'Show tour': 'Show tour',
        'Enable measure': 'Enable measure',
        'Show info': 'Show info',
        'Show model info': 'Show model info',
        'Show controls': 'Show controls',
        'Show fit to screen': 'Show fit to screen',
        'Show reset camera': 'Show reset camera',
        'Object Alignment': 'Alignment',
        'Alignment Mode': 'Alignment Mode',
        Move: 'Move',
        Rotate: 'Rotate',
        Helper: 'Helper',
        Box: 'Box',
        Target: 'Target',
        Object: 'Object',
        Operation: 'Operation',
        Scene: 'Scene',
        'Fit to Screen': 'Fit to Screen',
        Persp: 'Persp',
        Ortho: 'Ortho',
        'Perspective projection (click for orthographic)': 'Perspective projection (click for orthographic)',
        'Orthographic projection (click for perspective)': 'Orthographic projection (click for perspective)',
        'Reset View': 'Reset View',
        'Reset Pivot': 'Reset Pivot',
        Transform: 'Transform',
        Actions: 'Actions',
        'Floor Level': 'Floor Level',
        'Object Pivot': 'Object Pivot',
        'Object to Center': 'Object to Center',
        'Reset Object': 'Reset Object',
        'Dimension Box': 'Dimension Box',
        'Show dimension box': 'Show dimension box',
        'Box from Model Bounds': 'Box from Model Bounds',
        'Fit Box to Model': 'Fit Box to Model',
        Width: 'Width',
        Height: 'Height',
        Depth: 'Depth',
        'Model Bounds': 'Model Bounds',
        'Current Box Size': 'Current box size',
        'Original Model Bounds': 'Original model bounds',
        'Pivot Point: Center to Object': 'Pivot Point → Object Center',
        Auto: 'Auto',
        'Generated Embed Code': 'Generated Embed Code',
        'Copy Embed Code': 'Copy Embed Code',
        Full: 'Full',
        Compact: 'Compact',
        Minimal: 'Minimal',
        None: 'None',
        'HD / SD': 'HD / SD',
        'Camera mode': 'Camera mode',
        'Animation controls': 'Animation controls',
        'TAKE A SNAPSHOT AS PNG': 'TAKE A SNAPSHOT AS PNG',
        'COVER IMAGE (1:1)': 'COVER IMAGE (1:1)',
        'EXPORT VIEWER SETTINGS': 'EXPORT VIEWER SETTINGS',
        'Metadata (Dublin Core)': 'Metadata (Dublin Core)',
        Save: 'Save',
        Saved: 'Saved',
        Copied: 'Copied',
        Title: 'Title',
        Creator: 'Creator',
        Subject: 'Subject',
        Description: 'Description',
        Publisher: 'Publisher',
        Contributor: 'Contributor',
        Date: 'Date',
        Type: 'Type',
        Format: 'Format',
        Identifier: 'Identifier',
        Source: 'Source',
        Language: 'Language',
        Relation: 'Relation',
        Coverage: 'Coverage',
        Rights: 'Rights',
        Heritage: 'Heritage Database',
        EGROKN: 'EGROKN',
        'EGROKN level': 'EGROKN level',
        Federal: 'Federal',
        Regional: 'Regional',
        Municipal: 'Municipal',
        'Object number': 'Object number',
        'Museum item': 'Museum item',
        'Goskatalog link': 'Goskatalog link',
        'Import from API': 'Import from API',
        'API URL': 'API URL',
        Import: 'Import',
        'Importing...': 'Importing...',
        Imported: 'Imported',
        'Import failed': 'Import failed',
        'Enter API URL': 'Enter API URL',
        'File "{filename}" was not found on the server (HTTP {status}).': 'File "{filename}" was not found on the server (HTTP {status}).',
        'Download of "{filename}" stalled: no data for {seconds} s.': 'Download of "{filename}" stalled: no data for {seconds} s.',
        'Model "{filename}" did not finish preparing: no progress for {seconds} s.': 'Model "{filename}" did not finish preparing: no progress for {seconds} s.',
        'File "{filename}" is not accessible on the server (HTTP {status}).': 'File "{filename}" is not accessible on the server (HTTP {status}).',
        'File "{filename}" ({size}) exceeds model limit of 1 GB.': 'File "{filename}" ({size}) exceeds model limit of 1 GB.',
        'File "{filename}" ({size}) exceeds HDRI/Skybox limit of 50 MB.': 'File "{filename}" ({size}) exceeds HDRI/Skybox limit of 50 MB.',
        'File "{filename}" ({size}) exceeds settings limit of 10 MB.': 'File "{filename}" ({size}) exceeds settings limit of 10 MB.',
        'File "{filename}" has unsupported type "{extension}". Supported model formats: GLB, glTF, PLY, SOG, SPZ, 3TZ and tileset.json.': 'File "{filename}" has unsupported type "{extension}". Supported model formats: GLB, glTF, PLY, SOG, SPZ, 3TZ and tileset.json.',

        // Tour
        'Start tour': 'Start guided tour',
        Next: 'Next',
        Previous: 'Back',
        Done: 'Done',
        'Skip tour': 'Skip',
        'Tour: Alignment title': 'Step 1. Align the model',
        'Tour: Alignment body': 'Start here — position and orient the model correctly. Use Move / Rotate, set the object pivot, reset the transform or fit the scene to the screen.',
        'Tour: Measurement title': 'Step 2. Set the real scene scale',
        'Tour: Measurement body': 'If you know the real distance between two points on the model, open Measurement, pick those points and enter the known distance. The whole scene will be calibrated automatically.',
        'Tour: Camera title': 'Step 3. Initial camera view',
        'Tour: Camera body': 'Set the starting camera position, zoom and orbit. Here you can also pick the active camera, change FOV, tonemapping and turn on HD mode.',
        'Tour: Background title': 'Step 4. Background & environment',
        'Tour: Background body': 'Pick a solid background color, an HDRI environment or a dome / box projection. Tune exposure and rotation of the environment.',
        'Tour: Light title': 'Step 5. Scene lighting',
        'Tour: Light body': 'Turn the key light on/off, set its color, intensity and shadows, and enable the shadow catcher under the model.',
        'Tour: POI title': 'Step 6. Points of interest (optional)',
        'Tour: POI body': 'Add points of interest for a guided tour. POIs can be dragged directly on the model, given a color, title, description and a saved camera view.',
        'Tour: Metadata title': 'Step 7. Metadata',
        'Tour: Metadata body': 'Fill in Dublin Core fields (title, author, description, rights…). This metadata is shown in the Info panel next to the model.',
        'Tour: Export title': 'Step 8. Save settings',
        'Tour: Export body': 'Export all your choices as a settings file. If you put it next to the model, the viewer will load these settings automatically.',
        'Tour: Help button': 'Show the tour again'
    },
    ru: {
        'Load HDR surface': 'Загрузить HDR-поверхность',
        'Exposure (EV)': 'Экспозиция (EV)',
        'HDR surface: exposure and display mapping only.': 'HDR-поверхность: экспозиция и преобразование для экрана. Остальные постэффекты временно отключены.',
        'Use GLB texture': 'Вернуть текстуру GLB',
        'HDR source texture': 'Исходная HDR-текстура',
        'Environment brightness (EV)': 'Яркость окружения (EV)',
        'SDR LUT is applied in SDR preview only. Disable HDR output to see it.': 'SDR LUT применяется только в SDR-просмотре. Отключите HDR-вывод, чтобы увидеть его действие.',
        'HDR output: on. Click for SDR preview.': 'HDR включён. Нажмите для просмотра в SDR.',
        'SDR preview: click for HDR output.': 'Просмотр в SDR. Нажмите для HDR-вывода.',
        'HDR output is unavailable in this session. The HDR texture is shown in SDR.': 'HDR-вывод недоступен в этой сессии. HDR-текстура отображается в SDR.',
        Settings: 'Настройки',
        'Post-processing': 'ПОСТОБРАБОТКА',
        'Sharpness (RCAS)': 'Резкость (RCAS)',
        'Load LUT': 'Загрузить LUT',
        'Clear LUT': 'Удалить LUT',
        'LUT intensity': 'Сила LUT',
        'Colour vision profile': 'Профиль CVD',
        'No colour vision profile': 'Без профиля',
        'Colour vision profile could not be loaded': 'Не удалось загрузить профиль цветового зрения',
        'compensation profile suffix': 'комп.',
        'simulation profile suffix': 'сим.',
        'The list contains author simulations and experimental compensation profiles; the profile purpose is shown after its name.':
            'Список содержит предпросмотр для автора и экспериментальную компенсацию; назначение указано после названия профиля.',
        'SSAO intensity': 'Сила SSAO',
        'SSAO radius': 'Радиус SSAO',
        'Color LUT must be a horizontal strip, for example 256 x 16 pixels.': 'Color LUT должна быть горизонтальной полосой, например 256 × 16 пикселей.',
        'Color LUT file must be 8 MB or smaller.': 'Файл Color LUT должен быть не больше 8 МБ.',
        'Color LUT must be no larger than 4096 x 64 pixels (64³ colors).': 'Color LUT должна быть не больше 4096 × 64 пикселей (64³ цветов).',
        Materials: 'Материалы',
        POI: 'Точки интереса',
        Camera: 'КАМЕРА',
        Sky: 'ОКРУЖЕНИЕ',
        Light: 'СВЕТ',
        'Export viewer settings': 'Экспорт настроек',
        'Add POI': 'Добавить POI',
        'Clear POIs': 'Очистить POI',
        'No POIs yet.': 'Точек POI пока нет.',
        Delete: 'Удалить',
        'Click on the model surface to place a POI.': 'Кликните по поверхности модели, чтобы поставить POI.',
        'Capture View': 'Сохранить ракурс',
        'Retake View': 'Переснять ракурс',
        'Delete View': 'Удалить ракурс',
        'Active Camera': 'Активная камера',
        Fov: 'Угол обзора',
        Tonemap: 'Tonemap',
        'Pixel Scale': 'Масштаб пикселя',
        'Lower while moving': 'Понижать при движении (эксперимент)',
        'RCAS: contrast-adaptive sharpening from AMD FidelityFX FSR 1.0. Boosts edges and leaves flat areas untouched.':
            'RCAS: контрастно-адаптивная резкость из AMD FidelityFX FSR 1.0. Усиливает кромки и не трогает ровные участки.',
        'EASU: edge-preserving upscaling from AMD FidelityFX FSR 1.0. Works only when pixel scale is above one.':
            'EASU: повышение разрешения с восстановлением кромок из AMD FidelityFX FSR 1.0. Работает только при масштабе пикселя больше единицы.',
        'TAA combines current and previous frames to reduce jagged edges and shimmer. It can leave trails on moving objects.':
            'TAA объединяет текущий и предыдущие кадры, уменьшая ступеньки и мерцание. На движущихся объектах возможны шлейфы.',
        'Color LUT remaps the image colors using a lookup texture for consistent color grading.':
            'Color LUT переназначает цвета изображения по таблице для единой цветокоррекции.',
        'SSAO adds soft contact shadows in creases and where surfaces meet.':
            'SSAO добавляет мягкие контактные тени в углублениях и местах соприкосновения поверхностей.',
        'MSAA smooths polygon edges within one frame. It is automatically disabled when TAA is enabled.':
            'MSAA сглаживает края полигонов внутри одного кадра. При включении TAA отключается автоматически.',
        'Manual distance limits': 'Пределы расстояния вручную',
        'Camera limits': 'Ограничители камеры',
        'Tile loading order': 'Порядок загрузки тайлов',
        'Tiles': 'Тайлы',
        'Center of view first': 'Сначала центр кадра',
        'Under the cursor first': 'Сначала под курсором',
        'Around the grab point first': 'Сначала вокруг опорной точки',
        'By error and distance': 'Сначала самые грубые',
        'Min distance': 'Ближний предел',
        'Max distance': 'Дальний предел',
        'Current distance': 'Текущее расстояние',
        'Near from view': 'Ближний — из вида',
        'Far from view': 'Дальний — из вида',
        'Use the current camera distance as the near limit': 'Взять нынешнее расстояние камеры как ближний предел',
        'Use the current camera distance as the far limit': 'Взять нынешнее расстояние камеры как дальний предел',
        Viewport: 'Окно просмотра',
        Multisample: 'Мультисэмплинг',
        HD: 'HD',
        Environment: 'Окружение',
        'Environment Map': 'Карта окружения',
        Exposure: 'Экспозиция',
        Rotation: 'Поворот',
        Background: 'Фон',
        'Background Color': 'Цвет фона',
        Blur: 'Размытие',
        Scale: 'Масштаб',
        'Tripod Offset': 'Смещение штатива',
        Enabled: 'Включено',
        'Follow Camera': 'Следовать за камерой',
        Color: 'Цвет',
        Intensity: 'Интенсивность',
        'Cast Shadow': 'Отбрасывать тень',
        'Shadow Catcher': 'Ловушка теней',
        'Catcher Intensity': 'Интенсивность ловушки',
        'Catcher Height': 'Высота ловушки',
        'Current Device': 'Текущее устройство',
        'Graphics Backend': 'Графический бэкенд',
        'Active Backend': 'Активный бэкенд',
        'Auto (recommended)': 'Авто (рекомендуется)',
        'WebGPU is not available on this device': 'WebGPU недоступен на этом устройстве',
        'Switching restarts the viewer': 'Смена бэкенда перезапускает вьюер',
        'Use WebGPU': 'Использовать WebGPU',
        Grid: 'Сетка',
        Axes: 'Оси',
        Skeleton: 'Скелет',
        Bounds: 'Границы',
        Wireframe: 'Каркас',
        'Tiles Debug': 'Отладка тайлов',
        'Tile Bounds (OBB)': 'Границы тайлов (OBB)',
        'By State': 'По состоянию',
        'By LOD': 'По LOD',
        'By Resolution': 'По разрешению',
        'Isolate LOD': 'Изолировать LOD',
        'Replay loading': 'Перемотка загрузки',
        'Step back': 'Шаг назад',
        'Record again': 'Записать заново',
        'LOD {level} first appeared · frame {frame}': 'LOD {level} впервые появился · кадр {frame}',
        'LOD {level} last load in recording · frame {frame}': 'LOD {level}: последняя загрузка в записи · кадр {frame}',
        'POI timeline': 'Таймлайн точек интереса',
        'Observe camera externally': 'Наблюдать за камерой со стороны',
        'Time unit': 'Единицы времени',
        Timecode: 'Таймкод',
        Minutes: 'Минуты',
        Seconds: 'Секунды',
        Milliseconds: 'Миллисекунды',
        Frames: 'Кадры',
        'Camera transition': 'Переход камеры',
        Hold: 'Пауза',
        'Drag to change camera transition duration': 'Перетащите, чтобы изменить длительность перехода камеры',
        'Drag to change hold duration': 'Перетащите, чтобы изменить длительность паузы',
        'Add a POI to build the timeline': 'Добавьте точку интереса, чтобы построить таймлайн',
        'Start recording': 'Начать запись',
        'Stop recording': 'Остановить запись',
        'Exit timeline': 'Выйти из таймлайна',
        Loop: 'Зациклить',
        'Step forward': 'Шаг вперёд',
        'Rewinds the view along the recorded load order; leftmost position shows the scene as it is now.':
            'Отматывает показ по записанному порядку загрузки; крайнее левое положение — сцена как есть сейчас',
        'Load order': 'Порядок',
        'Tile ID': 'Номер тайла',
        'Tile labels': 'Подписи',
        'Leftmost position turns isolation off; further right shows only the chosen level.':
            'Крайнее левое положение выключает изоляцию; правее — показан только выбранный уровень',
        'Color the model': 'Раскрасить модель',
        'Colours tiles by how far their screen-space error is from the target: red is coarser than asked for, white is on target, blue is finer than needed.':
            'Красит тайлы по тому, насколько их экранная ошибка отличается от целевой: красный — грубее заказанного, белый — попадание, синий — детальнее необходимого.',
        'Spatial LOD Debug': 'Отладка spatial LOD',
        'Color Splats by LOD': 'Раскраска сплатов по LOD',
        'Color Tiles by LOD': 'Раскраска тайлов по LOD',
        'Spatial Node Bounds': 'Границы spatial-узлов',
        'LOD diagnostics use the live streaming state.': 'Диагностика показывает живое состояние стриминга.',
        'Freeze LOD Camera': 'Заморозить камеру LOD',
        'Line Thickness': 'Толщина линий',
        'Solid Frame': 'Ровный каркас',
        'Checker Frame': 'Шахматный каркас',
        'Checker Fill': 'Шахматная заливка',
        'Pick Tile': 'Выбрать тайл',
        'Load order numbers': 'Номера порядка загрузки',
        'Tile ID numbers': 'Номера тайлов (ID)',
        'Resume Loading': 'Продолжить загрузку',
        'Frame style': 'Вид каркаса',
        'Number within each LOD': 'Нумеровать внутри уровня',
        'Isolate Picked Tile': 'Изолировать выбранный тайл',
        'Freeze Camera + FOV': 'Заморозить камеру + FOV',
        'Pause Loading': 'Пауза загрузки',
        'Isolate LOD Level': 'Изолировать уровень LOD',
        'LOD Level': 'Уровень LOD',
        'Vertex Normals': 'Нормали вершин',
        'Wireframe Color': 'Цвет каркаса',
        'Checker Scale': 'Масштаб шахматки',
        'With texture': 'С текстурами',
        Geometry: 'ГЕОМЕТРИЯ',
        'Drag & drop .glb, .gltf, .ply, .sog, .spz or .3tz files, or click to open files': 'Перетащите .glb, .gltf, .ply, .sog, .spz или .3tz либо нажмите для открытия',
        'Click to open files': 'Нажмите для открытия файлов',
        OR: 'ИЛИ',
        'LOAD MODEL FROM URL': 'ЗАГРУЗИТЬ МОДЕЛЬ ПО URL',
        'ID': 'ID',
        'Info': 'Информация',
        Path: 'Путь',
        Name: 'Имя',
        'Copy path': 'Копировать путь',
        'TWIN_ID': 'TWIN_ID',
        'Copy TWIN_ID': 'Копировать TWIN_ID',
        'TWIN_ID not assigned': 'TWIN_ID не назначен',
        'Permanent digital twin identifier': 'Постоянный идентификатор цифрового двойника',
        'Left panel': 'Левая панель',
        'Tour': 'Тур',
        'Measure': 'Измерение',
        'Model info': 'О модели',
        'Fit': 'Вписать',
        'Reset': 'Сброс',
        'Interface elements': 'Элементы интерфейса',
        'Advanced': 'Дополнительно',
        'Parent origin': 'Origin родительского сайта',
        'Allowed parent site origin for embed messaging': 'Разрешённый origin родительского сайта для сообщений embed',
        'shown': 'показывать',
        'hidden': 'скрыто',
        'Show embed code': 'Показать код встройки',
        'Hide embed code': 'Скрыть код встройки',
        'Select a node in the hierarchy (Model tab).': 'Выберите узел в иерархии (вкладка Модель).',
        'HD mode': 'Режим HD',
        'SD mode': 'Режим SD',
        'Measurement': 'Измерение',
        'Fragment view': 'Просмотр фрагмента',
        'Highlight section outline': 'Подсветить контур сечения',
        'Outline width': 'Толщина линии',
        'SELECT FRAGMENT': 'ВЫБРАТЬ ФРАГМЕНТ',
        'CLICK MODEL TO PLACE BOX': 'КЛИКНИТЕ ПО МОДЕЛИ',
        'ISOLATE FRAGMENT': 'ИЗОЛИРОВАТЬ ФРАГМЕНТ',
        'EXIT ISOLATION': 'ВЫЙТИ ИЗ ИЗОЛЯЦИИ',
        'EXIT MODE': 'ВЫЙТИ ИЗ РЕЖИМА',
        'Click the model where the fragment box should appear.': 'Кликните по модели в месте, где должен появиться бокс.',
        'Adjust the box, then isolate the selected fragment.': 'Настройте бокс, затем изолируйте выбранный фрагмент.',
        'Enable clipping box': 'Включить бокс обрезки',
        'Move box': 'Перемещать бокс',
        'Resize box': 'Изменять размер бокса',
        'Rotate box': 'Поворачивать бокс',
        'Box shape': 'Бокс',
        'Sphere shape': 'Сфера',
        'Show outside box': 'Показывать снаружи бокса',
        Center: 'Центр',
        Size: 'Размер',
        'FIT BOX TO MODEL': 'БОКС ПО ГРАНИЦАМ МОДЕЛИ',
        'RESET VIEW': 'СБРОСИТЬ СРЕЗ',
        'The box clips geometry exactly; tile boundaries do not affect the cut.': 'Бокс точно обрезает геометрию независимо от границ тайлов.',
        'Export measurements JSON': 'Сохранить измерения в JSON',
        'View & share': 'Просмотр и поделиться',
        'Frame scene': 'Вписать сцену',
        'Orbit mode': 'Режим орбиты',
        'Fly mode': 'Режим полёта',
        'Walk mode': 'Режим ходьбы',
        'Fullscreen': 'Полный экран',
        'Exit fullscreen': 'Выйти из полноэкранного режима',
        'View in AR': 'Просмотр в AR',
        'Play': 'Воспроизведение',
        'Pause': 'Пауза',
        'Stop': 'Стоп',
        'Previous POI': 'Предыдущая точка',
        'Next POI': 'Следующая точка',
        'Texture resolution in pixels': 'Разрешение текстуры в пикселях',
        'GPU-compressed texture: the card reads it as is, no CPU unpacking': 'Сжатый для видеокарты формат: читается как есть, без распаковки процессором',
        'Uncompressed pixels: unpacked by the CPU and uploaded raw': 'Несжатые пиксели: распаковываются процессором и заливаются сырыми',
        Controls: 'Управление',
        'Theme color': 'Цвет темы',
        Model: 'Модель',
        About: 'О\u00a0программе',
        Desktop: 'Компьютер',
        Touch: 'Тачпад',
        'Orbit Mode': 'Режим орбиты',
        Orbit: 'Вращение',
        Pan: 'Панорама',
        Zoom: 'Масштаб',
        'Set Focus': 'Установить фокус',
        'Set Focus and Zoom One Step': 'Установить фокус и приблизить на шаг',
        'Fly Mode': 'Режим полёта',
        'Look Around': 'Обзор',
        Fly: 'Полёт',
        'Movement speed': 'Скорость перемещения',
        'Surface pivot': 'Опорная точка на поверхности',
        'Invert mouse buttons': 'Инвертировать кнопки мыши',
        'Pointer device': 'Устройство ввода',
        'Detect automatically': 'Определять автоматически',
        'Mouse': 'Мышь',
        'Trackpad': 'Трекпад',
        General: 'Общее',
        'Frame Scene': 'Вписать сцену',
        'Reset Camera': 'Сбросить камеру',
        'Left Mouse': 'Левая кнопка мыши',
        'Right Mouse': 'Правая кнопка мыши',
        'Mouse Wheel': 'Колёсико мыши',
        'Double Click': 'Двойной щелчок',
        'One Finger Drag': 'Одним пальцем',
        'Two Finger Drag': 'Двумя пальцами',
        Pinch: 'Сведение/разведение',
        'Double Tap': 'Двойное нажатие',
        'Touch on Right': 'Касание справа',
        'Touch on Left': 'Касание слева',
        Filename: 'Имя файла',
        Meshes: 'Меши',
        Textures: 'Текстуры',
        Primitives: 'Примитивы',
        Verts: 'Вершины',
        'Mesh VRAM': 'VRAM мешей',
        'Texture VRAM': 'VRAM текстур',
        'Texel Density': 'Плотность текселей',
        'Texel Density Top': 'Топ плотности текселей',
        'Pick object': 'Пипетка',
        Heatmap: 'Тепловая карта',
        'Selected object': 'Выбранный объект',
        'UV Layout': 'UV раскладка',
        'UV Set': 'UV set',
        'Active UV': 'Активный UV',
        'Material Variant': 'Вариант материала',
        'Texture Layers': 'Слои текстур',
        'Original material': 'Исходный материал',
        'Quick layer color': 'Цвет слоя в быстром переключателе',
        'Add layer to quick switcher': 'Добавить слой в быстрый переключатель',
        'PBR Factors': 'Параметры PBR',
        'By objects': 'По объектам',
        'Diffuse Color': 'Цвет diffuse',
        'Specular Color': 'Цвет specular',
        Metallic: 'Металличность',
        Roughness: 'Шероховатость',
        Opacity: 'Непрозрачность',
        'Enable By objects and click an object.': 'Включите По объектам и кликните по объекту.',
        'No editable PBR factors.': 'Для этого объекта нет редактируемых PBR-параметров.',
        'Texture Size': 'Размер текстуры',
        'Texture Channel': 'Канал текстуры',
        Triangles: 'Треугольники',
        'Surface Area': 'Площадь поверхности',
        Submaterial: 'Субматериал',
        'Enable object picker to inspect texel density.': 'Включите пипетку, чтобы проверить плотность текселей.',
        'Click an object in the viewport.': 'Кликните по объекту во вьюпорте.',
        'Texel Density by Material': 'Плотность текселей по материалам',
        'Load time': 'Время загрузки',
        Hierarchy: 'Иерархия',
        Variant: 'Вариант',
        'No model loaded. Drag & drop a glTF/GLB file.': 'Модель не загружена. Перетащите glTF/GLB файл.',
        'No hierarchy data.': 'Нет данных иерархии.',
        'No model loaded.': 'Модель не загружена.',
        Stats: 'Статистика',
        'Show performance stats': 'Показывать статистику производительности',
        'This viewer is a modified version of the open-source project PlayCanvas Model Viewer (MIT License):': 'Этот просмотрщик — модифицированная версия PlayCanvas Model Viewer (лицензия MIT):',
        'UI components are based on PlayCanvas PCUI (MIT License):': 'Компоненты интерфейса на основе PlayCanvas PCUI (лицензия MIT):',
        'Icons: Google Material Icons': 'Иконки: Google Material Symbols',
        'Flags: flag-icons': 'Флаги: flag-icons',
        'Tile streaming architecture inspired by NASA-AMMOS/3DTilesRendererJS (Apache License 2.0):': 'Архитектура потоковой загрузки тайлов вдохновлена NASA-AMMOS/3DTilesRendererJS (Apache License 2.0):',
        'Edge upscaling and sharpening use the AMD FidelityFX FSR 1.0 algorithms, EASU and RCAS (MIT License):': 'Повышение разрешения и резкость используют алгоритмы AMD FidelityFX FSR 1.0 — EASU и RCAS (лицензия MIT):',
        'HERITAGE3D.RU Project': 'Проект HERITAGE3D.RU',
        'Measure Mode': 'Режим измерения',
        'Enable measuring': 'Включить измерения',
        'Show helpers': 'Показывать хелперы',
        'Scale bar': 'Полоса масштаба',
        'Scene scale': 'Масштаб сцены',
        'Clear measurements': 'Очистить измерения',
        'Click to change units': 'Нажмите, чтобы сменить единицы',
        'Click and enter the real length': 'Нажмите и впишите реальную длину',
        'Or enter the real length on the segment label': 'Либо впишите реальную длину прямо в подпись отрезка',
        Step: 'Шаг',
        'scale at the measured segment': 'масштаб на глубине измеренного отрезка',
        'scale at the surface in the centre of the frame': 'масштаб на поверхности в центре кадра',
        'Reference Figure': 'Эталонная фигура',
        Human: 'Человек',
        Units: 'Единицы',
        'millimeters (mm)': 'миллиметры (мм)',
        'centimeters (cm)': 'сантиметры (см)',
        'meters (m)': 'метры (м)',
        '1 Unit = (m)': '1 единица = (м)',
        'Known distance': 'Известное расстояние',
        'Only one known segment can be used for scene scale. A new distance replaces the previous one.': 'Для масштаба сцены можно использовать только один известный отрезок. Новое расстояние заменит предыдущее.',
        'RECALCULATE SCENE SIZE': 'ПЕРЕСЧИТАТЬ РАЗМЕР СЦЕНЫ',
        'Last Distance': 'Последнее расстояние',
        'Last Angle': 'Последний угол',
        'Last Area': 'Последняя площадь',
        'Planarity deviation': 'Отклонение от плоскости',
        'Distance tool': 'Измерение расстояния',
        'Angle tool': 'Измерение угла',
        'Area tool': 'Измерение площади',
        Points: 'Точки',
        'Pick first point': 'Выберите первую точку',
        'Pick second point': 'Выберите вторую точку',
        'Pick third point': 'Выберите третью точку',
        'Pick fourth point': 'Выберите четвёртую точку',
        'Pick next point or close polygon': 'Выберите следующую точку или замкните многоугольник',
        'CLEAR MEASUREMENT': 'ОЧИСТИТЬ ИЗМЕРЕНИЕ',
        'CLEAR MEASUREMENTS': 'ОЧИСТИТЬ ИЗМЕРЕНИЯ',
        'View and share on mobile with QR code': 'Просмотр и отправка на мобильное по QR-коду',
        'View and share on mobile with URL': 'Просмотр и отправка на мобильное по URL',
        'Embed Type': 'Тип встраивания',
        Responsive: 'Адаптивный',
        Fixed: 'Фиксированный',
        'UI Preset': 'Пресет интерфейса',
        'Show left panel': 'Показывать левую панель',
        Autoplay: 'Автозапуск',
        'Allow fullscreen': 'Разрешить fullscreen',
        'Show POI': 'Показывать POI',
        'Show tour': 'Показывать тур',
        'Enable measure': 'Включить измерения',
        'Show info': 'Показывать Info',
        'Show model info': 'Показывать сведения о модели',
        'Show controls': 'Показывать Controls',
        'Show fit to screen': 'Показывать вписать в экран',
        'Show reset camera': 'Показывать сброс камеры',
        'Object Alignment': 'Выравнивание',
        'Alignment Mode': 'Режим выравнивания',
        Move: 'Перемещение',
        Rotate: 'Поворот',
        Helper: 'Хелпер',
        Box: 'Бокс',
        Target: 'Цель',
        Object: 'Объект',
        Operation: 'Операция',
        Scene: 'Сцена',
        'Fit to Screen': 'Вписать в экран',
        Persp: 'Персп',
        Ortho: 'Орто',
        'Perspective projection (click for orthographic)': 'Проекция: перспектива (клик → ортогональная)',
        'Orthographic projection (click for perspective)': 'Проекция: ортогональная (клик → перспектива)',
        'Reset View': 'Сбросить вид',
        'Reset Pivot': 'Сбросить пивот',
        Transform: 'Трансформация',
        Actions: 'Действия',
        'Floor Level': 'Уровень пола',
        'Object Pivot': 'Пивот объекта',
        'Object to Center': 'Объект в центр',
        'Reset Object': 'Сбросить объект',
        'Dimension Box': 'Размерный бокс',
        'Show dimension box': 'Показывать размерный бокс',
        'Box from Model Bounds': 'Бокс по границам модели',
        'Fit Box to Model': 'Обтянуть боксом модель',
        Width: 'Ширина',
        Height: 'Высота',
        Depth: 'Глубина',
        'Model Bounds': 'Границы модели',
        'Current Box Size': 'Текущий размер бокса',
        'Original Model Bounds': 'Исходные границы модели',
        'Pivot Point: Center to Object': 'Pivot Point → в центр объекта',
        Auto: 'Авто',
        'Generated Embed Code': 'Сгенерированный embed-код',
        'Copy Embed Code': 'Скопировать embed-код',
        Full: 'Полный',
        Compact: 'Компактный',
        Minimal: 'Минимальный',
        None: 'Без элементов',
        'HD / SD': 'HD / SD',
        'Camera mode': 'Режим камеры',
        'Animation controls': 'Управление анимацией',
        'TAKE A SNAPSHOT AS PNG': 'СДЕЛАТЬ СНИМОК PNG',
        'COVER IMAGE (1:1)': 'ОБЛОЖКА (1:1)',
        'EXPORT VIEWER SETTINGS': 'ЭКСПОРТ НАСТРОЕК',
        'Metadata (Dublin Core)': 'Метаданные (Dublin Core)',
        Save: 'Сохранить',
        Saved: 'Сохранено',
        Copied: 'Скопировано',
        Title: 'Название',
        Creator: 'Автор',
        Subject: 'Тема',
        Description: 'Описание',
        Publisher: 'Издатель',
        Contributor: 'Вкладчик',
        Date: 'Дата',
        Type: 'Тип',
        Format: 'Формат',
        Identifier: 'Идентификатор',
        Source: 'Источник',
        Language: 'Язык',
        Relation: 'Связь',
        Coverage: 'Охват',
        Rights: 'Права',
        Heritage: 'Heritage Database',
        EGROKN: 'ЕГРОКН',
        'EGROKN level': 'Уровень значения ЕГРОКН',
        Federal: 'Федеральный',
        Regional: 'Региональный',
        Municipal: 'Муниципальный',
        'Object number': 'Номер объекта',
        'Museum item': 'Музейный предмет',
        'Goskatalog link': 'Ссылка на Госкаталог',
        'Import from API': 'Импорт из API',
        'API URL': 'URL API',
        Import: 'Импорт',
        'Importing...': 'Импорт...',
        Imported: 'Импортировано',
        'Import failed': 'Ошибка импорта',
        'Enter API URL': 'Введите URL API',
        'File "{filename}" was not found on the server (HTTP {status}).': 'Файл "{filename}" не найден на сервере (HTTP {status}).',
        'Download of "{filename}" stalled: no data for {seconds} s.': 'Загрузка "{filename}" остановилась: данные не идут {seconds} с.',
        'Model "{filename}" did not finish preparing: no progress for {seconds} s.': 'Модель "{filename}" не доготовилась: подготовка не движется {seconds} с.',
        'File "{filename}" is not accessible on the server (HTTP {status}).': 'Файл "{filename}" недоступен на сервере (HTTP {status}).',
        'File "{filename}" ({size}) exceeds model limit of 1 GB.': 'Файл "{filename}" ({size}) превышает лимит модели 1 ГБ.',
        'File "{filename}" ({size}) exceeds HDRI/Skybox limit of 50 MB.': 'Файл "{filename}" ({size}) превышает лимит HDRI/Skybox в 50 МБ.',
        'File "{filename}" ({size}) exceeds settings limit of 10 MB.': 'Файл "{filename}" ({size}) превышает лимит файла настроек 10 МБ.',
        'File "{filename}" has unsupported type "{extension}". Supported model formats: GLB, glTF, PLY, SOG, SPZ, 3TZ and tileset.json.': 'Файл "{filename}" имеет неподдерживаемый тип "{extension}". Поддерживаемые форматы моделей: GLB, glTF, PLY, SOG, SPZ, 3TZ и tileset.json.',

        // Tour
        'Start tour': 'Запустить обучение',
        Next: 'Далее',
        Previous: 'Назад',
        Done: 'Готово',
        'Skip tour': 'Пропустить',
        'Tour: Alignment title': 'Шаг 1. Выравнивание модели',
        'Tour: Alignment body': 'Начните с выравнивания — правильно разместите и поверните модель. Режимы «Move / Rotate», установка точки опоры (pivot), сброс трансформации и кнопка «Fit to Screen».',
        'Tour: Measurement title': 'Шаг 2. Масштаб сцены',
        'Tour: Measurement body': 'Если вы знаете реальное расстояние между двумя точками модели — откройте «Измерения» внизу, отметьте эти точки и задайте известное расстояние. Вся сцена автоматически получит правильный масштаб.',
        'Tour: Camera title': 'Шаг 3. Начальный ракурс камеры',
        'Tour: Camera body': 'Настройте стартовое положение, зум и орбиту камеры. Здесь же выбирается активная камера, FOV, тонмэппинг и HD-режим.',
        'Tour: Background title': 'Шаг 4. Фон и окружение',
        'Tour: Background body': 'Выберите сплошной цвет фона, HDRI-окружение или проекционный купол / бокс. Отрегулируйте экспозицию и поворот окружения.',
        'Tour: Light title': 'Шаг 5. Освещение сцены',
        'Tour: Light body': 'Включите/выключите основной свет, задайте его цвет, интенсивность и тени, активируйте «ловушку теней» под моделью.',
        'Tour: POI title': 'Шаг 6. Точки интереса (по желанию)',
        'Tour: POI body': 'При желании добавьте точки интереса — POI. Их можно перетаскивать прямо по модели, задавать цвет, название, описание и сохранять ракурс камеры для каждой.',
        'Tour: Metadata title': 'Шаг 7. Метаданные',
        'Tour: Metadata body': 'Заполните поля Dublin Core (название, автор, описание, права…). Эти данные будут показаны в панели «Информация» рядом с моделью.',
        'Tour: Export title': 'Шаг 8. Сохраните файл настроек',
        'Tour: Export body': 'Экспортируйте все выбранные настройки в файл. Если положить его рядом с моделью — просмотрщик подхватит эти настройки автоматически при загрузке.',
        'Tour: Help button': 'Показать тур снова'
    },
    zh: {
        'Load HDR surface': '加载 HDR 表面',
        'Exposure (EV)': '曝光 (EV)',
        'HDR surface: exposure and display mapping only.': 'HDR 表面：仅曝光和显示映射。',
        'Use GLB texture': '使用 GLB 纹理',
        'HDR source texture': 'HDR 源纹理',
        'Environment brightness (EV)': '环境亮度 (EV)',
        'SDR LUT is applied in SDR preview only. Disable HDR output to see it.': 'SDR LUT 仅用于 SDR 预览。关闭 HDR 输出以查看效果。',
        'HDR output: on. Click for SDR preview.': 'HDR 已开启。点击预览 SDR。',
        'SDR preview: click for HDR output.': 'SDR 预览。点击输出 HDR。',
        'HDR output is unavailable in this session. The HDR texture is shown in SDR.': '此会话不支持 HDR 输出。HDR 纹理以 SDR 显示。',
        Settings: '设置',
        'Post-processing': '后期处理',
        'Sharpness (RCAS)': '锐度 (RCAS)',
        'Load LUT': '加载 LUT',
        'Clear LUT': '清除 LUT',
        'LUT intensity': 'LUT 强度',
        'Colour vision profile': 'CVD 配置',
        'No colour vision profile': '无配置文件',
        'Colour vision profile could not be loaded': '无法加载色觉配置文件',
        'compensation profile suffix': '补偿',
        'simulation profile suffix': '作者预览',
        'The list contains author simulations and experimental compensation profiles; the profile purpose is shown after its name.':
            '列表包含作者预览和实验性补偿，配置用途显示在名称之后。',
        'SSAO intensity': 'SSAO 强度',
        'SSAO radius': 'SSAO 半径',
        'Color LUT must be a horizontal strip, for example 256 x 16 pixels.': 'Color LUT 必须是水平条带，例如 256 × 16 像素。',
        'Color LUT file must be 8 MB or smaller.': 'Color LUT 文件不得超过 8 MB。',
        'Color LUT must be no larger than 4096 x 64 pixels (64³ colors).': 'Color LUT 不得大于 4096 × 64 像素（64³ 种颜色）。',
        Materials: '材质',
        POI: '兴趣点',
        Camera: '相机',
        Sky: '环境',
        Light: '光源',
        'Export viewer settings': '导出查看器设置',
        'Add POI': '添加 POI',
        'Clear POIs': '清除 POI',
        'No POIs yet.': '还没有 POI。',
        Delete: '删除',
        'Click on the model surface to place a POI.': '点击模型表面放置 POI。',
        'Capture View': '保存视角',
        'Retake View': '重新保存视角',
        'Delete View': '删除视角',
        'Active Camera': '活动相机',
        Fov: '视场角',
        Tonemap: '色调映射',
        'Pixel Scale': '像素缩放',
        'Lower while moving': '移动时降低（实验性）',
        'RCAS: contrast-adaptive sharpening from AMD FidelityFX FSR 1.0. Boosts edges and leaves flat areas untouched.':
            'RCAS：来自 AMD FidelityFX FSR 1.0 的对比度自适应锐化。只增强边缘，不影响平坦区域。',
        'EASU: edge-preserving upscaling from AMD FidelityFX FSR 1.0. Works only when pixel scale is above one.':
            'EASU：来自 AMD FidelityFX FSR 1.0 的边缘保持放大。仅在像素比例大于 1 时生效。',
        'TAA combines current and previous frames to reduce jagged edges and shimmer. It can leave trails on moving objects.':
            'TAA 合并当前帧与历史帧，以减少锯齿和闪烁；移动物体可能出现拖影。',
        'Color LUT remaps the image colors using a lookup texture for consistent color grading.':
            'Color LUT 使用查找纹理重新映射画面颜色，以实现统一调色。',
        'SSAO adds soft contact shadows in creases and where surfaces meet.':
            'SSAO 在凹槽和表面接触处增加柔和的接触阴影。',
        'MSAA smooths polygon edges within one frame. It is automatically disabled when TAA is enabled.':
            'MSAA 在单帧内平滑多边形边缘；启用 TAA 时会自动关闭。',
        'Manual distance limits': '手动距离限制',
        'Camera limits': '相机限制',
        'Tile loading order': '瓦片加载顺序',
        'Tiles': '瓦片',
        'Center of view first': '优先视野中心',
        'Under the cursor first': '优先光标位置',
        'Around the grab point first': '优先支点周围',
        'By error and distance': '优先最粗糙',
        'Min distance': '最近距离',
        'Max distance': '最远距离',
        'Current distance': '当前距离',
        'Near from view': '从当前视图取近限',
        'Far from view': '从当前视图取远限',
        'Use the current camera distance as the near limit': '将当前相机距离设为最近限制',
        'Use the current camera distance as the far limit': '将当前相机距离设为最远限制',
        Viewport: '视口',
        Multisample: '多重采样',
        HD: '高清',
        Environment: '环境',
        'Environment Map': '环境贴图',
        Exposure: '曝光',
        Rotation: '旋转',
        Background: '背景',
        'Background Color': '背景颜色',
        Blur: '模糊',
        Scale: '缩放',
        'Tripod Offset': '三脚架偏移',
        Enabled: '启用',
        'Follow Camera': '跟随相机',
        Color: '颜色',
        Intensity: '强度',
        'Cast Shadow': '投射阴影',
        'Shadow Catcher': '阴影捕获',
        'Catcher Intensity': '捕获强度',
        'Catcher Height': '捕获高度',
        'Current Device': '当前设备',
        'Graphics Backend': '图形后端',
        'Active Backend': '当前后端',
        'Auto (recommended)': '自动（推荐）',
        'WebGPU is not available on this device': '此设备不支持 WebGPU',
        'Switching restarts the viewer': '切换后端将重启查看器',
        'Use WebGPU': '使用 WebGPU',
        Grid: '网格',
        Axes: '坐标轴',
        Skeleton: '骨架',
        Bounds: '边界',
        Wireframe: '线框',
        'Tiles Debug': '瓦片调试',
        'Tile Bounds (OBB)': '瓦片边界 (OBB)',
        'By State': '按状态',
        'By LOD': '按 LOD',
        'By Resolution': '按分辨率',
        'Isolate LOD': '隔离 LOD',
        'Replay loading': '加载回放',
        'Step back': '后退一步',
        'Record again': '重新记录',
        'LOD {level} first appeared · frame {frame}': 'LOD {level} 首次出现 · 帧 {frame}',
        'LOD {level} last load in recording · frame {frame}': 'LOD {level} 在记录中的最后一次加载 · 帧 {frame}',
        'POI timeline': '兴趣点时间轴',
        'Observe camera externally': '从外部观察相机',
        'Time unit': '时间单位',
        Timecode: '时间码',
        Minutes: '分钟',
        Seconds: '秒',
        Milliseconds: '毫秒',
        Frames: '帧',
        'Camera transition': '相机过渡',
        Hold: '停留',
        'Drag to change camera transition duration': '拖动以更改相机过渡时长',
        'Drag to change hold duration': '拖动以更改停留时长',
        'Add a POI to build the timeline': '添加兴趣点以创建时间轴',
        'Start recording': '开始录制',
        'Stop recording': '停止录制',
        'Exit timeline': '退出时间轴',
        Loop: '循环',
        'Step forward': '前进一步',
        'Rewinds the view along the recorded load order; leftmost position shows the scene as it is now.':
            '按记录的加载顺序回放；最左位置显示当前场景。',
        'Load order': '加载顺序',
        'Tile ID': '瓦片编号',
        'Tile labels': '标注',
        'Leftmost position turns isolation off; further right shows only the chosen level.':
            '最左位置关闭隔离；向右则只显示所选层级。',
        'Color the model': '为模型着色',
        'Colours tiles by how far their screen-space error is from the target: red is coarser than asked for, white is on target, blue is finer than needed.':
            '按瓦片屏幕空间误差与目标值的偏差着色：红色表示比目标更粗糙，白色表示达标，蓝色表示超出所需精度。',
        'Spatial LOD Debug': 'Spatial LOD 调试',
        'Color Splats by LOD': '按 LOD 为点着色',
        'Color Tiles by LOD': '按 LOD 为瓦片着色',
        'Spatial Node Bounds': 'Spatial 节点边界',
        'LOD diagnostics use the live streaming state.': '诊断显示实时流式加载状态。',
        'Freeze LOD Camera': '冻结 LOD 相机',
        'Line Thickness': '线条粗细',
        'Solid Frame': '均匀边框',
        'Checker Frame': '棋盘边框',
        'Checker Fill': '棋盘填充',
        'Pick Tile': '拾取瓦片',
        'Load order numbers': '加载顺序编号',
        'Tile ID numbers': '瓦片编号',
        'Resume Loading': '继续加载',
        'Frame style': '线框样式',
        'Number within each LOD': '按层级内编号',
        'Isolate Picked Tile': '隔离所选瓦片',
        'Freeze Camera + FOV': '冻结相机与视锥',
        'Pause Loading': '暂停加载',
        'Isolate LOD Level': '隔离 LOD 层级',
        'LOD Level': 'LOD 层级',
        'Vertex Normals': '顶点法线',
        'Wireframe Color': '线框颜色',
        'Checker Scale': '棋盘缩放',
        'With texture': '仅显示有纹理',
        Geometry: '几何',
        'Drag & drop .glb, .gltf, .ply, .sog, .spz or .3tz files, or click to open files': '拖放 .glb、.gltf、.ply、.sog、.spz 或 .3tz 文件，或点击打开',
        'Click to open files': '点击打开文件',
        OR: '或',
        'LOAD MODEL FROM URL': '从 URL 加载模型',
        'ID': 'ID',
        'Info': '信息',
        Path: '路径',
        Name: '名称',
        'Copy path': '复制路径',
        'TWIN_ID': 'TWIN_ID',
        'Copy TWIN_ID': '复制 TWIN_ID',
        'TWIN_ID not assigned': 'TWIN_ID 未分配',
        'Permanent digital twin identifier': '数字孪生的永久标识符',
        'Left panel': '左侧面板',
        'Tour': '导览',
        'Measure': '测量',
        'Model info': '模型信息',
        'Fit': '适配',
        'Reset': '重置',
        'Interface elements': '界面元素',
        'Advanced': '高级',
        'Parent origin': '父页面来源',
        'Allowed parent site origin for embed messaging': '允许进行嵌入消息通信的父站点来源',
        'shown': '显示',
        'hidden': '隐藏',
        'Show embed code': '显示嵌入代码',
        'Hide embed code': '隐藏嵌入代码',
        'Select a node in the hierarchy (Model tab).': '在层级中选择节点（模型标签页）。',
        'HD mode': '高清模式',
        'SD mode': '标清模式',
        'Measurement': '测量',
        'Fragment view': '局部视图',
        'Highlight section outline': '高亮剖切轮廓',
        'Outline width': '轮廓线宽',
        'SELECT FRAGMENT': '选择局部',
        'CLICK MODEL TO PLACE BOX': '点击模型放置裁剪框',
        'ISOLATE FRAGMENT': '隔离局部',
        'EXIT ISOLATION': '退出隔离',
        'EXIT MODE': '退出模式',
        'Click the model where the fragment box should appear.': '点击模型以放置局部裁剪框。',
        'Adjust the box, then isolate the selected fragment.': '调整裁剪框，然后隔离所选局部。',
        'Enable clipping box': '启用裁剪框',
        'Move box': '移动裁剪框',
        'Resize box': '调整裁剪框大小',
        'Rotate box': '旋转裁剪框',
        'Box shape': '立方体',
        'Sphere shape': '球体',
        'Show outside box': '显示裁剪框外部',
        Center: '中心',
        Size: '尺寸',
        'FIT BOX TO MODEL': '裁剪框适配模型',
        'RESET VIEW': '重置裁剪',
        'The box clips geometry exactly; tile boundaries do not affect the cut.': '裁剪框会精确裁剪几何体，不受瓦片边界影响。',
        'Export measurements JSON': '导出测量 JSON',
        'View & share': '查看与分享',
        'Frame scene': '适配场景',
        'Orbit mode': '轨道模式',
        'Fly mode': '飞行模式',
        'Walk mode': '步行模式',
        'Fullscreen': '全屏',
        'Exit fullscreen': '退出全屏',
        'View in AR': 'AR 查看',
        'Play': '播放',
        'Pause': '暂停',
        'Stop': '停止',
        'Previous POI': '上一个兴趣点',
        'Next POI': '下一个兴趣点',
        'Texture resolution in pixels': '纹理分辨率（像素）',
        'GPU-compressed texture: the card reads it as is, no CPU unpacking': 'GPU 压缩纹理：显卡直接读取，无需 CPU 解压',
        'Uncompressed pixels: unpacked by the CPU and uploaded raw': '未压缩像素：由 CPU 解压后原样上传',
        Controls: '控制',
        'Theme color': '主题颜色',
        Model: '模型',
        About: '关于',
        Desktop: '桌面',
        Touch: '触控',
        'Orbit Mode': '轨道模式',
        Orbit: '旋转',
        Pan: '平移',
        Zoom: '缩放',
        'Set Focus': '设置焦点',
        'Set Focus and Zoom One Step': '设置焦点并放大一步',
        'Fly Mode': '飞行模式',
        'Look Around': '环视',
        Fly: '飞行',
        'Movement speed': '移动速度',
        'Surface pivot': '表面旋转支点',
        'Invert mouse buttons': '交换鼠标左右键',
        'Pointer device': '指点设备',
        'Detect automatically': '自动检测',
        'Mouse': '鼠标',
        'Trackpad': '触控板',
        General: '常规',
        'Frame Scene': '适配场景',
        'Reset Camera': '重置相机',
        'Left Mouse': '左键',
        'Right Mouse': '右键',
        'Mouse Wheel': '鼠标滚轮',
        'Double Click': '双击',
        'One Finger Drag': '单指拖动',
        'Two Finger Drag': '双指拖动',
        Pinch: '双指缩放',
        'Double Tap': '双指点击',
        'Touch on Right': '右侧触控',
        'Touch on Left': '左侧触控',
        Filename: '文件名',
        Meshes: '网格',
        Textures: '纹理',
        Primitives: '图元',
        Verts: '顶点',
        'Mesh VRAM': '网格显存',
        'Texture VRAM': '纹理显存',
        'Texel Density': '纹素密度',
        'Texel Density Top': '纹素密度 TOP',
        'Pick object': '拾取对象',
        Heatmap: '热力图',
        'Selected object': '已选对象',
        'UV Layout': 'UV 布局',
        'UV Set': 'UV 集',
        'Active UV': '当前 UV',
        'Material Variant': '材质变体',
        'Texture Layers': '纹理图层',
        'Original material': '原始材质',
        'Quick layer color': '快速切换器中的图层颜色',
        'Add layer to quick switcher': '将图层添加到快速切换器',
        'PBR Factors': 'PBR 参数',
        'By objects': '按对象',
        'Diffuse Color': '漫反射颜色',
        'Specular Color': '高光颜色',
        Metallic: '金属度',
        Roughness: '粗糙度',
        Opacity: '不透明度',
        'Enable By objects and click an object.': '启用按对象并点击对象。',
        'No editable PBR factors.': '该对象没有可编辑的 PBR 参数。',
        'Texture Size': '纹理尺寸',
        'Texture Channel': '纹理通道',
        Triangles: '三角形',
        'Surface Area': '表面积',
        Submaterial: '子材质',
        'Enable object picker to inspect texel density.': '启用拾取器以检查纹素密度。',
        'Click an object in the viewport.': '在视口中点击一个对象。',
        'Texel Density by Material': '按材质查看纹素密度',
        'Load time': '加载时间',
        Hierarchy: '层级',
        Variant: '变体',
        'No model loaded. Drag & drop a glTF/GLB file.': '未加载模型。拖放 glTF/GLB 文件。',
        'No hierarchy data.': '无层级数据。',
        'No model loaded.': '未加载模型。',
        Stats: '统计',
        'Show performance stats': '显示性能统计',
        'This viewer is a modified version of the open-source project PlayCanvas Model Viewer (MIT License):': '此查看器是 PlayCanvas Model Viewer (MIT 许可) 的修改版：',
        'UI components are based on PlayCanvas PCUI (MIT License):': 'UI 组件基于 PlayCanvas PCUI (MIT 许可)：',
        'Icons: Google Material Icons': '图标: Google Material Symbols',
        'Flags: flag-icons': '旗帜: flag-icons',
        'Tile streaming architecture inspired by NASA-AMMOS/3DTilesRendererJS (Apache License 2.0):': '瓦片流式加载架构参考了 NASA-AMMOS/3DTilesRendererJS（Apache License 2.0）：',
        'Edge upscaling and sharpening use the AMD FidelityFX FSR 1.0 algorithms, EASU and RCAS (MIT License):': '超分辨率与锐化采用 AMD FidelityFX FSR 1.0 的 EASU 与 RCAS 算法 (MIT 许可)：',
        'HERITAGE3D.RU Project': 'HERITAGE3D.RU 项目',
        'Measure Mode': '测量模式',
        'Enable measuring': '启用测量',
        'Show helpers': '显示辅助点',
        'Scale bar': '比例尺',
        'Scene scale': '场景比例',
        'Clear measurements': '清除测量',
        'Click to change units': '点击切换单位',
        'Click and enter the real length': '点击并输入实际长度',
        'Or enter the real length on the segment label': '也可直接在线段标签上输入实际长度',
        Step: '刻度',
        'scale at the measured segment': '比例尺按所测线段的深度计算',
        'scale at the surface in the centre of the frame': '比例尺按画面中心处表面的深度计算',
        'Reference Figure': '参考人形',
        Human: '人物',
        Units: '单位',
        'millimeters (mm)': '毫米 (mm)',
        'centimeters (cm)': '厘米 (cm)',
        'meters (m)': '米 (m)',
        '1 Unit = (m)': '1 单位 = (米)',
        'Known distance': '已知距离',
        'Only one known segment can be used for scene scale. A new distance replaces the previous one.': '场景比例只能使用一个已知线段。新的距离会替换上一个距离。',
        'RECALCULATE SCENE SIZE': '重新计算场景大小',
        'Last Distance': '最后距离',
        'Last Angle': '最后角度',
        'Last Area': '最后面积',
        'Planarity deviation': '平面偏差',
        'Distance tool': '距离工具',
        'Angle tool': '角度工具',
        'Area tool': '面积工具',
        Points: '点',
        'Pick first point': '选择第一个点',
        'Pick second point': '选择第二个点',
        'Pick third point': '选择第三个点',
        'Pick fourth point': '选择第四个点',
        'Pick next point or close polygon': '选择下一个点或闭合多边形',
        'CLEAR MEASUREMENT': '清除测量',
        'CLEAR MEASUREMENTS': '清除测量',
        'View and share on mobile with QR code': '通过 QR 码在手机上查看和分享',
        'View and share on mobile with URL': '通过 URL 在手机上查看和分享',
        'Embed Type': '嵌入类型',
        Responsive: '自适应',
        Fixed: '固定尺寸',
        'UI Preset': '界面预设',
        'Show left panel': '显示左侧面板',
        Autoplay: '自动播放',
        'Allow fullscreen': '允许全屏',
        'Show POI': '显示 POI',
        'Show tour': '显示导览',
        'Enable measure': '启用测量',
        'Show info': '显示信息',
        'Show model info': '显示模型信息',
        'Show controls': '显示控制',
        'Show fit to screen': '显示适配场景',
        'Show reset camera': '显示重置相机',
        'Object Alignment': '对齐',
        'Alignment Mode': '对齐模式',
        Move: '移动',
        Rotate: '旋转',
        Helper: '辅助对象',
        Box: '包围盒',
        Target: '目标',
        Object: '对象',
        Operation: '操作方式',
        Scene: '场景',
        'Fit to Screen': '适应屏幕',
        Persp: '透视',
        Ortho: '正交',
        'Perspective projection (click for orthographic)': '透视投影（点击切换为正交）',
        'Orthographic projection (click for perspective)': '正交投影（点击切换为透视）',
        'Reset View': '重置视图',
        'Reset Pivot': '重置枢轴',
        Transform: '变换',
        Actions: '操作',
        'Floor Level': '地面高度',
        'Object Pivot': '对象枢轴',
        'Object to Center': '对象居中',
        'Reset Object': '重置对象',
        'Fit Box to Model': '包围盒贴合模型',
        'Current Box Size': '当前包围盒尺寸',
        'Original Model Bounds': '模型原始边界',
        'Pivot Point: Center to Object': '枢轴点：居中到对象',
        Auto: '自动',
        'Generated Embed Code': '生成的嵌入代码',
        'Copy Embed Code': '复制嵌入代码',
        Full: '完整',
        Compact: '紧凑',
        Minimal: '极简',
        None: '无界面元素',
        'HD / SD': 'HD / SD',
        'Camera mode': '相机模式',
        'Animation controls': '动画控件',
        'TAKE A SNAPSHOT AS PNG': '保存 PNG 截图',
        'COVER IMAGE (1:1)': '封面图 (1:1)',
        'EXPORT VIEWER SETTINGS': '导出查看器设置',
        'Metadata (Dublin Core)': '元数据 (Dublin Core)',
        Save: '保存',
        Saved: '已保存',
        Copied: '已复制',
        Title: '标题',
        Creator: '创作者',
        Subject: '主题',
        Description: '描述',
        Publisher: '出版者',
        Contributor: '贡献者',
        Date: '日期',
        Type: '类型',
        Format: '格式',
        Identifier: '标识符',
        Source: '来源',
        Language: '语言',
        Relation: '关联',
        Coverage: '覆盖范围',
        Rights: '权利',
        Heritage: 'Heritage Database',
        EGROKN: 'ЕГРОКН',
        'EGROKN level': 'ЕГРОКН 级别',
        Federal: '联邦',
        Regional: '地区',
        Municipal: '市政',
        'Object number': '对象编号',
        'Museum item': '博物馆藏品',
        'Goskatalog link': 'Госкаталог 链接',
        'Import from API': '从 API 导入',
        'API URL': 'API URL',
        Import: '导入',
        'Importing...': '导入中...',
        Imported: '已导入',
        'Import failed': '导入失败',
        'Enter API URL': '请输入 API URL',
        'File "{filename}" was not found on the server (HTTP {status}).': '服务器上未找到文件“{filename}”（HTTP {status}）。',
        'Download of "{filename}" stalled: no data for {seconds} s.': '“{filename}”的下载已停滞：{seconds} 秒内没有数据。',
        'Model "{filename}" did not finish preparing: no progress for {seconds} s.': '模型“{filename}”未能完成准备：{seconds} 秒内没有进展。',
        'File "{filename}" is not accessible on the server (HTTP {status}).': '文件“{filename}”在服务器上不可访问（HTTP {status}）。',
        'File "{filename}" ({size}) exceeds model limit of 1 GB.': '文件“{filename}”（{size}）超过模型大小上限 1 GB。',
        'File "{filename}" ({size}) exceeds HDRI/Skybox limit of 50 MB.': '文件“{filename}”（{size}）超过 HDRI/Skybox 大小上限 50 MB。',
        'File "{filename}" ({size}) exceeds settings limit of 10 MB.': '文件“{filename}”（{size}）超过设置文件大小上限 10 MB。',
        'File "{filename}" has unsupported type "{extension}". Supported model formats: GLB, glTF, PLY, SOG, SPZ, 3TZ and tileset.json.': '文件“{filename}”的类型“{extension}”不受支持。支持的模型格式：GLB、glTF、PLY、SOG、SPZ、3TZ 和 tileset.json。',

        // Tour
        'Start tour': '开始引导教程',
        Next: '下一步',
        Previous: '上一步',
        Done: '完成',
        'Skip tour': '跳过',
        'Tour: Alignment title': '第 1 步：对齐模型',
        'Tour: Alignment body': '从对齐开始——正确放置和旋转模型。可以切换“Move / Rotate”模式、设置物体支点、重置变换或一键适配到屏幕。',
        'Tour: Measurement title': '第 2 步：设置场景比例',
        'Tour: Measurement body': '如果您知道模型上两点之间的真实距离，请打开下方的“测量”功能，点选这两点并输入已知距离，整个场景的比例将自动校准。',
        'Tour: Camera title': '第 3 步：相机的初始视角',
        'Tour: Camera body': '设置相机的起始位置、缩放和轨道。您还可以选择活动相机、视场角 (FOV)、色调映射，并启用 HD 模式。',
        'Tour: Background title': '第 4 步：背景与环境',
        'Tour: Background body': '选择纯色背景、HDRI 环境或穹顶 / 盒子投影。调整环境的曝光和旋转。',
        'Tour: Light title': '第 5 步：场景照明',
        'Tour: Light body': '开关主光源，设置其颜色、强度和阴影，并启用模型下方的“阴影接收器”。',
        'Tour: POI title': '第 6 步：兴趣点（可选）',
        'Tour: POI body': '如需要可以添加兴趣点 (POI)，在模型上直接拖动它们，设置颜色、标题、描述并保存对应的相机视角。',
        'Tour: Metadata title': '第 7 步：元数据',
        'Tour: Metadata body': '填写 Dublin Core 字段（标题、作者、描述、版权……）。这些信息会显示在模型旁的“信息”面板中。',
        'Tour: Export title': '第 8 步：保存设置文件',
        'Tour: Export body': '将所选设置导出为文件。如果把它放在模型旁边，查看器将在加载时自动读取这些设置。',
        'Tour: Help button': '再次显示教程'
    }
};

export const t = (key: string, lang: Lang | string | undefined): string => {
    const l = (lang as Lang) || 'en';
    return translations[l]?.[key] ?? translations.en?.[key] ?? key;
};
